import React from "react";
import { analyticsAndMarketingCookieName } from "./CookieControl";

export type CookieConsents = {
  [analyticsAndMarketingCookieName]: boolean;
};

export type CookieConsentContextType = {
  cookieConsents: CookieConsents | undefined;
  setCookieConsents: (cookieConsents: CookieConsents) => void;
};

// Initialize the context with an empty object. It will be filled with actual values by the Provider.
export const CookieConsentContext = React.createContext<CookieConsentContextType | undefined>(undefined);
